import { useTranslation } from "react-i18next";
import { Box, Chip, TextField } from "@mui/material";

import { PaymentLinksSearchIcon } from "../../../../../assets/icons/MUI/PaymentIcons";
import { colors } from "../../../../../theme/palette";

import { TableControlProps } from "../../../payment.types";

const TableControl = ({ activeState, setActiveState, value, handleOnValueChange }: TableControlProps) => {
  const { t } = useTranslation();

  const tabs = ["success", "failed"];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        padding: "12px 16px",
        flexDirection: { xs: "column", sm: "row" },
        gap: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          border: "1px solid #D0D5DD",
          height: "fit-content",
          borderRadius: "8px",
          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
          overflow: "hidden",
        }}
      >
        {tabs.map((tab, idx) => (
          <Chip
            key={tab}
            label={t(`pages.payment.paymentLinks.${tab}`)}
            variant="outlined"
            sx={{
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
              color: tab === activeState ? colors.Green100 : "#344054",
              backgroundColor: tab === activeState ? "#F0F5F4" : "",
              border: "none",
              borderRadius: "0",
              borderRight: idx !== tabs.length - 1 ? "1px solid #D0D5DD" : "",
              padding: "10px 16px",
            }}
            onClick={() => setActiveState((prevValue: string) => (prevValue === tab ? "" : tab))}
          />
        ))}
      </Box>
      <TextField
        value={value}
        onChange={handleOnValueChange}
        placeholder={t("pages.payment.paymentLinks.search")}
        InputProps={{
          endAdornment: <PaymentLinksSearchIcon style={{ fill: "none", width: "24px", height: "24px" }} />,
          autoComplete: "new-password",
        }}
        variant="outlined"
        sx={{
          width: "320px",
          "& .MuiOutlinedInput-root": {
            padding: "0 14px",
            borderRadius: "8px",
          },
        }}
      />
    </Box>
  );
};

export default TableControl;
